const Style = {

  base: 'relative block text-sm mb-2 uppercase',
  error: 'text-red-500 -ml-4 z-2',
  required: `after:text-red-500 after:ml-1 after:font-semibold after:content-['*']`

}

export default Style;